"use client";

import React from "react";
import { CompanyCard } from "../components/CompanyCard";

const FunctionalTestingPage: React.FC = () => {
  return (
    <div className="p-6 md:p-10 bg-[var(--color-brand)] min-h-screen">
      <h1 className="text-3xl text-[var(--text-on-dark)] text-center font-bold mb-6">Functional Testing Companies</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Example Company 1 */}
        <CompanyCard
          name="Company A"
          link="https://www.companya.com"
          overview="Company A specializes in providing high-quality functional testing services for web and mobile applications."
          icon={<span className="text-4xl">🏢</span>}
        />

        {/* Example Company 2 */}
        <CompanyCard
          name="Company B"
          link="https://www.companyb.com"
          overview="Company B offers comprehensive testing solutions, ensuring your software meets all functional requirements."
          icon={<span className="text-4xl">💻</span>}
        />

        {/* Example Company 3 */}
        <CompanyCard
          name="Company C"
          link="https://www.companyc.com"
          overview="Company C provides cutting-edge tools and expertise for functional testing across various industries."
          icon={<span className="text-4xl">🔧</span>}
        />
      </div>
    </div>
  );
};

export default FunctionalTestingPage;